export default {
  namespaced: true,
  state: {
    error: null,
    success: null,
    warning: null,
  },
  mutations: {
    SET_ERROR: (state, text) => {
      state.error = text;
    },
    DELETE_ERROR: (state) => {
      state.error = null;
    },
    SET_WARNING: (state, text) => {
      state.warning = text;
    },
    DELETE_WARNING: (state) => {
      state.warning = null;
    },
    SET_SUCCESS: (state, text) => {
      state.success = text;
    },
    DELETE_SUCCESS: (state) => {
      state.success = null;
    }
  },
  actions: {
    setError: ({commit}, text) => {
      commit('SET_ERROR', text);
    },
    deleteError: ({commit}) => {
      commit('DELETE_ERROR');
    },
    setWarning: ({commit}, text) => {
      commit('SET_WARNING', text);
    },
    deleteWarning: ({commit}) => {
      commit('DELETE_WARNING');
    },
    setSuccess: ({commit}, text) => {
      commit('SET_SUCCESS', text);
    },
    deleteSuccess: ({commit}) => {
      commit('DELETE_SUCCESS');
    }
  },
  getters: {
    getError: (state) => {
      return state.error;
    },
    getWarning: (state) => {
      return state.warning;
    },
    getSuccess: (state) => {
      return state.success;
    }
  }
}